import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="user-notifications"
export default class extends Controller {
  static targets = ["container", "clearAllButton", "notification"];
  connect() {
    this.placeholder = this.containerTarget.innerHTML;
    this.notificationTargetsChanged();
  }

  resetNotifications() {
    this.containerTarget.innerHTML = this.placeholder;
  }

  notificationTargetsChanged() {
    if (this.notificationTargets.length > 0) {
      this.clearAllButtonTarget.classList.remove("hidden");
    } else {
      this.clearAllButtonTarget.classList.add("hidden");
    }
  }

  notificationTargetConnected() {
    this.notificationTargetsChanged();
  }

  notificationTargetDisconnected() {
    this.notificationTargetsChanged();
  }
}
